/**
 * Timezone handling utilities
 */

import moment from "moment-timezone";

/**
 * Default timezone to use when browser timezone cannot be detected
 */
export const DEFAULT_TIMEZONE = "America/New_York";

/**
 * Get timezone abbreviation from IANA identifier using moment-timezone
 * @param {string} timezone - IANA timezone identifier (e.g., "America/Montevideo")
 * @returns {string} Timezone abbreviation (e.g., "UYT", "EST", "PST")
 */
export const getTimezoneAbbreviation = (timezone) => {
  if (!timezone) return "";

  try {
    return moment.tz(timezone).zoneAbbr();
  } catch (_unused) {
    // If timezone is invalid, return it as-is
    return timezone;
  }
};

/**
 * Get the browser's timezone
 * Uses Intl.DateTimeFormat to detect the user's timezone
 */
export const getBrowserTimezone = () => {
  try {
    // Modern browsers support this
    return Intl.DateTimeFormat().resolvedOptions().timeZone || DEFAULT_TIMEZONE;
  } catch (_unused) {
    // Fallback to Eastern Time if detection fails
    return DEFAULT_TIMEZONE;
  }
};
